((window, document, undefined) => {
  "use strict";

  const $ = window.jQuery;

  const scrollToCommentSection = () => {
    const commentSection = document.querySelector(
      ".vodl-comment-section__textarea-wrapper"
    );
    if (window.location.hash.includes("#amp") && commentSection !== null) {
      commentSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const init = () => {
    window.addEventListener("load", scrollToCommentSection);

    document.addEventListener("vodl_interaction_clicked", function (ev) {
      if (ev.detail?.interaction?.type === "tipp") {
        const readerSuggestions = document.querySelector(
          ".vodl-region-article__reader-suggestions"
        );

        if (readerSuggestions) {
          if (readerSuggestions.hasAttribute("hidden")) {
            readerSuggestions.removeAttribute("hidden");
          } else {
            readerSuggestions.setAttribute("hidden", true);
          }
        }
      }
    });
  };

  $(document).ready(init);
})(window, document);
